import { useNavigate } from "react-router";

import { t } from "i18next";

import { Box, Button } from "@mui/material";

import { theme } from "@/src/theme/theme";

import FAQSingleAccordion from "@/src/components/atoms/FAQSingleAccordion/FAQSingleAccordion";

import AB_TEST_IDS from "@/src/constants/abTestIds";
import {
  CARAVAN_TYPE_CARAVAN,
  CARAVAN_TYPE_STORAGE_TRAILER,
  type CaravanType
} from "@/src/utils/caravanTypes";

export type FAQLink = {
  url: string;
  text: string;
};

export type FAQItem = {
  id: number;
  title: string;
  content: string;
  links?: FAQLink[];
  stepIds: number[];
  listCarItems?: string[];
  listMotoItems?: string[];
  /** Hide this FAQ when caravanType is one of these (e.g. Matkailuvaunu, Talovaunu) */
  hideForCaravanTypes?: CaravanType[];
};

interface FAQJsonType {
  data: FAQItem[];
}

export const FAQJson: FAQJsonType = {
  data: [
    {
      id: 1,
      title: "title-1",
      content: "content-1",
      stepIds: [0, 1]
    },
    {
      id: 2,
      title: "title-2",
      content: "content-2",
      links: [
        {
          text: "link-2-1",
          url: "https://baana.nettiauto.com/blog/nain-autoliikkeet-hinnoittelevat-autosi"
        }
      ],
      stepIds: [0, 1, 3, 9]
    },
    {
      id: 3,
      title: "title-3",
      content: "content-3",
      stepIds: [0, 1, 9]
    },
    {
      id: 4,
      title: "title-4",
      content: "content-4",
      stepIds: [0, 1]
    },
    {
      id: 5,
      title: "title-5",
      content: "content-5",
      stepIds: [0, 1]
    },
    {
      id: 6,
      title: "title-6",
      content: "content-6",
      stepIds: [1, 10]
    },
    {
      id: 7,
      title: "title-7",
      content: "content-7",
      stepIds: [0, 1, 10]
    },
    {
      id: 8,
      title: "title-8",
      content: "content-8",
      links: [
        {
          text: "link-8-1",
          url: "https://baana.nettiauto.com/blog/rahoitetun-auton-myynti---nain-myyt-rahoitusyhtion-omistaman-auton"
        }
      ],
      stepIds: [2]
    },
    {
      id: 9,
      title: "title-9",
      content: "content-9",
      stepIds: [5, 7]
    },
    {
      id: 10,
      title: "title-10",
      content: "content-10",
      stepIds: [0, 1, 2, 5]
    },
    {
      id: 11,
      title: "title-11",
      content: "content-11",
      stepIds: [0, 10]
    },
    {
      id: 12,
      title: "title-12",
      content: "content-12",
      stepIds: [3]
    },
    {
      id: 13,
      title: "title-13",
      content: "content-13",
      stepIds: [3],
      hideForCaravanTypes: [CARAVAN_TYPE_CARAVAN, CARAVAN_TYPE_STORAGE_TRAILER]
    },
    {
      id: 14,
      title: "title-14",
      content: "content-14",
      stepIds: [3, 4]
    },
    {
      id: 15,
      title: "title-15",
      content: "content-15",
      stepIds: [8]
    },
    {
      id: 16,
      title: "title-16",
      content: "content-16",
      stepIds: [6],
      listCarItems: [
        "Etuviistosta",
        "Edestä",
        "Takaviistosta",
        "Takaa",
        "Sivulta",
        "Kojetaulusta auto käynnissä"
      ],
      listMotoItems: [
        "Etuviistosta",
        "Takaviistosta",
        "Molemmilta sivuilta",
        "Mittaristosta/Hytistä virrat päällä",
        "Eturenkaasta",
        "Takarenkaasta"
      ]
    },
    {
      id: 17,
      title: "title-17",
      content: "content-17",
      stepIds: [1, 5]
    },
    {
      id: 18,
      title: "title-18",
      content: "content-18",
      stepIds: [10, 11]
    },
    {
      id: 19,
      title: "title-19",
      content: "content-19",
      stepIds: [10]
    },
    {
      id: 20,
      title: "title-20",
      content: "content-20",
      stepIds: [2]
    },
    {
      id: 21,
      title: "title-21",
      content: "content-21",
      stepIds: [0, 1, 9]
    },
    {
      id: 22,
      title: "title-22",
      content: "content-22",
      stepIds: []
    },
    {
      id: 23,
      title: "title-23",
      content: "content-23",
      stepIds: []
    },
    {
      id: 24,
      title: "title-24",
      content: "content-24",
      stepIds: []
    },
    {
      id: 25,
      title: "title-25",
      content: "content-25",
      stepIds: []
    },
    {
      id: 26,
      title: "title-26",
      content: "content-26",
      stepIds: []
    },
    {
      id: 27,
      title: "title-27",
      content: "content-27",
      stepIds: []
    },
    {
      id: 28,
      title: "title-28",
      content: "content-28",
      stepIds: []
    },
    {
      id: 29,
      title: "title-29",
      content: "content-29",
      stepIds: []
    },
    {
      id: 30,
      title: "title-30",
      content: "content-30",
      stepIds: []
    },
    {
      id: 31,
      title: "title-31",
      content: "content-31",
      stepIds: []
    },
    {
      id: 32,
      title: "title-32",
      content: "content-32",
      stepIds: []
    },
    {
      id: 33,
      title: "title-33",
      content: "content-33",
      stepIds: []
    },
    {
      id: 34,
      title: "title-34",
      content: "content-34",
      stepIds: []
    },
    {
      id: 35,
      title: "title-35",
      content: "content-35",
      stepIds: []
    },
    {
      id: 36,
      title: "title-36",
      content: "content-36",
      stepIds: []
    },
    {
      id: 37,
      title: "title-37",
      content: "content-37",
      stepIds: []
    },
    {
      id: 38,
      title: "title-38",
      content: "content-38",
      stepIds: []
    },
    {
      id: 39,
      title: "title-39",
      content: "content-39",
      stepIds: []
    },
    {
      id: 40,
      title: "title-40",
      content: "content-40",
      stepIds: []
    },
    {
      id: 41,
      title: "title-41",
      content: "content-41",
      stepIds: []
    },
    {
      id: 42,
      title: "title-42",
      content: "content-42",
      stepIds: []
    },
    {
      id: 43,
      title: "title-43",
      content: "content-43",
      links: [
        {
          text: "link-43-1",
          url: "https://www.etua.fi/autolaina?source=90155"
        }
      ],
      stepIds: [9]
    },
    {
      id: 44,
      title: "title-44",
      content: "content-44",
      stepIds: []
    },
    {
      id: 45,
      title: "title-45",
      content: "content-45",
      stepIds: []
    },
    {
      id: 46,
      title: "title-46",
      content: "content-46",
      stepIds: []
    },
    {
      id: 47,
      title: "title-47",
      content: "content-47",
      stepIds: []
    },
    {
      id: 202311291,
      title: "title-202311291",
      content: "content-202311291",
      stepIds: []
    },
    {
      id: 202311292,
      title: "title-202311292",
      content: "content-202311292",
      stepIds: []
    },
    {
      id: 202504011,
      title: "title-202504011",
      content: "content-202504011",
      stepIds: []
    },
    {
      id: 202504013,
      title: "title-202504013",
      content: "content-202504013",
      stepIds: []
    },
    {
      id: 48,
      title: "title-48",
      content: "content-48",
      stepIds: [0, 1, 2]
    },
    {
      id: 49,
      title: "title-49",
      content: "content-49",
      stepIds: [0, 1]
    },
    {
      id: 50,
      title: "title-50",
      content: "content-50",
      stepIds: [10]
    },
    {
      id: 51,
      title: "title-51",
      content: "content-51",
      stepIds: [10]
    },
    {
      id: 52,
      title: "title-52",
      content: "content-52",
      stepIds: []
    },
    {
      id: 53,
      title: "title-53",
      content: "content-53",
      stepIds: [10, 11]
    },
    {
      id: 54,
      title: "title-54",
      content: "content-54",
      stepIds: [10, 11]
    },
    {
      id: 55,
      title: "title-55",
      content: "content-55",
      links: [
        {
          text: "link-55-1",
          url: "https://www.almamobility.fi/myyntitietojen-ilmoittaminen-verottajalle-dac7-direktiivin-mukaisesti/"
        }
      ],
      stepIds: [10, 11]
    }
  ]
};

export const getFaqsInOrder = (ids: readonly number[]): FAQItem[] =>
  ids
    .map((id) => FAQJson.data.find((item) => item.id === id))
    .filter((item): item is FAQItem => item !== undefined);

export const FAQJsonOld: FAQJsonType = {
  data: [
    {
      id: 1,
      title: "title-1",
      content: "content-1",
      stepIds: [0, 1]
    },
    {
      id: 2,
      title: "title-2",
      content: "content-2",
      links: [
        {
          text: "link-2-1",
          url: "https://baana.nettiauto.com/blog/miten-auton-renkaiden-kunto-arvioidaan"
        }
      ],
      stepIds: [0, 1, 2]
    },
    {
      id: 3,
      title: "title-3",
      content: "content-3",
      stepIds: [0, 1, 2]
    },
    {
      id: 4,
      title: "title-4",
      content: "content-4",
      links: [
        {
          text: "link-4-1",
          url: "https://nettiauto.com"
        }
      ],
      stepIds: [0, 1]
    },
    {
      id: 5,
      title: "title-5",
      content: "content-5",
      stepIds: [0, 1]
    },
    {
      id: 6,
      title: "title-6",
      content: "content-6",
      stepIds: [1, 2, 10]
    },
    {
      id: 7,
      title: "title-7",
      content: "content-7",
      stepIds: [0, 1, 10]
    },
    {
      id: 8,
      title: "title-8",
      content: "content-8",
      links: [
        {
          text: "link-8-1",
          url: "https://baana.nettiauto.com/blog/rahoitetun-auton-myynti---nain-myyt-rahoitusyhtion-omistaman-auton"
        }
      ],
      stepIds: [3]
    },
    {
      id: 9,
      title: "title-9",
      content: "content-9",
      stepIds: [6, 8]
    },
    {
      id: 10,
      title: "title-10",
      content: "content-10",
      stepIds: [0, 1, 3, 6]
    },
    {
      id: 11,
      title: "title-11",
      content: "content-11",
      stepIds: [0, 10]
    },
    {
      id: 12,
      title: "title-12",
      content: "content-12",
      stepIds: [4, 5]
    },
    {
      id: 13,
      title: "title-13",
      content: "content-13",
      stepIds: [4, 5]
    },
    {
      id: 14,
      title: "title-14",
      content: "content-14",
      stepIds: [3, 4, 5]
    },
    {
      id: 15,
      title: "title-15",
      content: "content-15",
      stepIds: [9]
    },
    {
      id: 16,
      title: "title-16",
      content: "content-16",
      stepIds: [7],
      listCarItems: [
        "Etuviistosta",
        "Edestä",
        "Takaviistosta",
        "Takaa",
        "Sivulta",
        "Kojetaulusta auto käynnissä"
      ]
    },
    {
      id: 17,
      title: "title-17",
      content: "content-17",
      stepIds: [1, 2, 6]
    },
    {
      id: 18,
      title: "title-18",
      content: "content-18",
      stepIds: [10, 11]
    },
    {
      id: 19,
      title: "title-19",
      content: "content-19",
      stepIds: [10]
    },
    {
      id: 20,
      title: "title-20",
      content: "content-20",
      stepIds: [9]
    },
    {
      id: 21,
      title: "title-21",
      content: "content-21",
      stepIds: [0, 1, 2]
    },
    {
      id: 22,
      title: "title-22",
      content: "content-22",
      stepIds: []
    },
    {
      id: 23,
      title: "title-23",
      content: "content-23",
      stepIds: []
    },
    {
      id: 24,
      title: "title-24",
      content: "content-24",
      stepIds: []
    },
    {
      id: 25,
      title: "title-25",
      content: "content-25",
      stepIds: []
    },
    {
      id: 26,
      title: "title-26",
      content: "content-26",
      stepIds: []
    },
    {
      id: 27,
      title: "title-27",
      content: "content-27",
      stepIds: []
    },
    {
      id: 28,
      title: "title-28",
      content: "content-28",
      stepIds: []
    },
    {
      id: 29,
      title: "title-29",
      content: "content-29",
      stepIds: []
    },
    {
      id: 30,
      title: "title-30",
      content: "content-30",
      stepIds: []
    },
    {
      id: 31,
      title: "title-31",
      content: "content-31",
      stepIds: []
    },
    {
      id: 32,
      title: "title-32",
      content: "content-32",
      stepIds: []
    },
    {
      id: 33,
      title: "title-33",
      content: "content-33",
      stepIds: []
    },
    {
      id: 34,
      title: "title-34",
      content: "content-34",
      stepIds: []
    },
    {
      id: 35,
      title: "title-35",
      content: "content-35",
      stepIds: []
    },
    {
      id: 36,
      title: "title-36",
      content: "content-36",
      stepIds: []
    },
    {
      id: 37,
      title: "title-37",
      content: "content-37",
      stepIds: []
    },
    {
      id: 38,
      title: "title-38",
      content: "content-38",
      stepIds: []
    },
    {
      id: 39,
      title: "title-39",
      content: "content-39",
      stepIds: []
    },
    {
      id: 40,
      title: "title-40",
      content: "content-40",
      stepIds: []
    },
    {
      id: 41,
      title: "title-41",
      content: "content-41",
      stepIds: []
    },
    {
      id: 42,
      title: "title-42",
      content: "content-42",
      stepIds: []
    },
    {
      id: 43,
      title: "title-43",
      content: "content-43",
      links: [
        {
          text: "link-43-1",
          url: "https://www.etua.fi/autolaina?source=90155"
        }
      ],
      stepIds: [2]
    },
    {
      id: 202311291,
      title: "title-202311291",
      content: "content-202311291",
      stepIds: []
    },
    {
      id: 202311292,
      title: "title-202311292",
      content: "content-202311292",
      stepIds: []
    },
    {
      id: 202504011,
      title: "title-202504011",
      content: "content-202504011",
      stepIds: []
    }
  ]
};

const FAQList = () => {
  const homePageFaqIds = [1, 7, 3, 4, 2, 8, 48];
  const homePageFaq = getFaqsInOrder(homePageFaqIds);

  const navigate = useNavigate();

  const handleNavigation = (url: string) => {
    navigate(url);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: ["column"],
        alignItems: "center",
        marginTop: 3,
        ul: {
          paddingLeft: 0,
          marginBlockStart: 0,
          marginBlockEnd: 0,
          listStyleType: "none",
          "&:first-of-type": {
            marginRight: [0, 0, theme.spacing(2)]
          },
          ".MuiAccordionSummary-root": {
            borderTop: "white 1px solid"
          }
        }
      }}
    >
      <ul>
        {homePageFaq.map((singleFaq, idx) => (
          <li key={singleFaq.id}>
            <FAQSingleAccordion item={singleFaq} index={idx + 1} />
          </li>
        ))}
      </ul>
      <Button
        onClick={() => handleNavigation("/faq")}
        variant="contained"
        sx={{
          width: ["100%", "150px", "150px"],
          mt: 2
        }}
        data-ab-test={AB_TEST_IDS.consumer.homepage.faq.readMore}
      >
        {t("faq.readMore")}
      </Button>
    </Box>
  );
};

export default FAQList;
